import { render, staticRenderFns } from "./UpdateMasterLevel.vue?vue&type=template&id=49b2c912"
import script from "./UpdateMasterLevel.vue?vue&type=script&lang=js"
export * from "./UpdateMasterLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports